import type { Payment } from "@/model/order/payment"
import { MollieRefundStatus } from "@/model/payment/mollie-refund-status"

/**
 * Semantic kind of a booked payment, so lists can label failed refunds and their compensating reversal bookings
 * distinctly instead of guessing from the amount sign alone.
 */
export type PaymentKind = "reversal" | "failedRefund" | "canceledRefund" | "pendingRefund" | "refund" | "paid"

const pendingRefundStatuses = [MollieRefundStatus.Queued, MollieRefundStatus.Pending, MollieRefundStatus.Processing]

export function paymentKind(payment: Payment): PaymentKind {
    if (payment.isRefundReversal) {
        return "reversal"
    }
    if (payment.mollieRefundStatus === MollieRefundStatus.Failed) {
        return "failedRefund"
    }
    if (payment.mollieRefundStatus === MollieRefundStatus.Canceled) {
        return "canceledRefund"
    }
    if (payment.mollieRefundStatus && pendingRefundStatuses.includes(payment.mollieRefundStatus)) {
        return "pendingRefund"
    }
    if ((payment.amount ?? 0) < 0) {
        return "refund"
    }
    return "paid"
}
